import { useMemo, useState } from 'react';
import { useFormState } from 'react-hook-form';
import isEmpty from 'lodash/isEmpty';
import { selectIsJourneySettingsRefactorFeatureFlagOn } from 'core/userContext';
import { useSelector } from 'react-redux';
import { SettingsTab } from '../SettingsTakeover.constants';
import { useRuleBuilder } from '../../RuleBuilder/hooks/useRuleBuilder';

export const useTabValidationOld = () => {
  const { errors } = useFormState();
  const { validationErrors } = useRuleBuilder();
  const [runValidation, setRunValidation] = useState(false);

  const invalidTabs = useMemo(() => {
    if (runValidation) {
      const exitRuleTab = !isEmpty(validationErrors) ? [SettingsTab.ExitRules] : [];
      const conversionAndMetricsTab = !isEmpty(errors) ? [SettingsTab.ConversionsAndMetrics] : [];
      const tabs = [...exitRuleTab, ...conversionAndMetricsTab];
      if (tabs.length === 0) {
        setRunValidation(false);
      }
      return tabs;
    }
    return [];
  }, [runValidation, validationErrors, JSON.stringify(errors)]);

  return {
    runValidation: () => setRunValidation(true),
    invalidTabs,
  };
};

export const useTabValidationNew = (currentTab: SettingsTab) => {
  const { errors } = useFormState();
  const { validationErrors } = useRuleBuilder();
  const [runValidation, setRunValidation] = useState(false);

  const invalidTabs = useMemo(() => {
    if (runValidation) {
      let tabs = [] as SettingsTab[];
      if (currentTab === SettingsTab.ExitRules) {
        tabs = !isEmpty(validationErrors) ? [SettingsTab.ExitRules] : [];
      } else if (currentTab === SettingsTab.ConversionsAndMetrics) {
        tabs = !isEmpty(errors) ? [SettingsTab.ConversionsAndMetrics] : [];
      }
      if (tabs.length === 0) {
        setRunValidation(false);
      }
      return tabs;
    }
    return [];
  }, [runValidation, validationErrors, JSON.stringify(errors)]);

  return {
    runValidation: () => setRunValidation(true),
    invalidTabs,
  };
};

export const useTabValidation = (props?: any) => {
  const isJourneySettingsFeatureFlagEnabled = useSelector(
    selectIsJourneySettingsRefactorFeatureFlagOn,
  );
  const useTabValidationFn = isJourneySettingsFeatureFlagEnabled
    ? useTabValidationNew
    : useTabValidationOld;
  return useTabValidationFn(props);
};
